import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { EnpsControlComponent } from '@common/controls/enps-control/enps-control';

@Component({
    selector: 'st-toggle-control',
    templateUrl: './toggle-control.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleControlComponent extends EnpsControlComponent<boolean> {
    public valueChanged(value: MatSlideToggleChange) {
        this.changed.emit(value.checked);
    }
}
